import { render, staticRenderFns } from "./CreateQuestion.vue?vue&type=template&id=3a5fe220"
import script from "./CreateQuestion.vue?vue&type=script&lang=js"
export * from "./CreateQuestion.vue?vue&type=script&lang=js"
import style0 from "./CreateQuestion.vue?vue&type=style&index=0&id=3a5fe220&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports